module.exports = __webpack_public_path__ + "img/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.87c279f6.webp";